import { render } from "./CFormGroup.vue?vue&type=template&id=27914a09"
import script from "./CFormGroup.vue?vue&type=script&lang=js"
export * from "./CFormGroup.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__